import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TypeTrip, TypeTrips } from 'src/app/core/resources/service-request/type-trip';

@Component({
  selector: 'app-trip-type-field',
  templateUrl: './trip-type-field.component.html',
  styleUrls: ['./trip-type-field.component.scss']
})
export class TripTypeFieldComponent implements OnInit {

  public typeTrips: TypeTrip[] = TypeTrips;
  @Input() inputFormControl: FormControl;

  constructor() { }

  ngOnInit() {
  }

  public onSelect($event: any): void {
    console.log($event);
  }
}
